import Vue from 'vue'

Vue.filter('currency', valor => {
  return `R$ ${parseFloat(valor).toFixed(2)}`.replace('.',',')
})

Vue.filter('percent', valor => {
  return `${valor} %`
})

Vue.filter('parcel', valor => {
  return `x ${valor}`
})

Vue.filter('text', valor => {
  return `${valor.slice(0, 30)}...`
})
